import { Form } from 'antd';
import { RevxCheckbox } from 'components';
import { RevxCheckboxProps } from 'components/RevxCheckbox';
import { ConfigSvcProps } from '..';
import CommonJobSvcImg from './CommonJobSvcImg';

const CommonJobSvcName = (props: ConfigSvcProps) => {
  const { id, jobOptionSvc, isRequired } = props;

  const nameCheckboxProps: RevxCheckboxProps = {
    iconSequence: 'last',
    outSideRevxLayoutProps: {
      align: 'top',
      justify: 'left',
      wrap: 'wrap',
      className: 'jobconfig-jobOption-content-outSideOption-default',
      style: {
        paddingBottom: 0,
        marginTop: 0,
      },
    },
    inSideRevxLayoutProps: {
      direction: 'column',
      align: 'center',
      justify: 'left',
      className: 'jobconfig-jobOption-content-inSideOption-default',
      style: {
        textAlign: 'center',
      },
    },
    options: [
      {
        value: jobOptionSvc?.name,
        children: (
          <>
            <CommonJobSvcImg
              {...props}
              revxId={jobOptionSvc.revxId}
              revxTypeId={jobOptionSvc.revxTypeId}
            />
            <span style={{ padding: '10px 0px', width: '140px' }}>
              {jobOptionSvc?.name}
            </span>
          </>
        ),
      },
    ],
  };

  return (
    <>
      <div className="base-service-container-name">
        {Boolean(isRequired) && (
          <>
            <CommonJobSvcImg
              {...props}
              revxId={jobOptionSvc.revxId}
              revxTypeId={jobOptionSvc.revxTypeId}
            />
            <div className="jobconfig-jobOption-content-inSideOption-default jobconfig-jobOption-content-inSideOption-required">
              <span>{jobOptionSvc.name}</span>
            </div>
          </>
        )}
        <div hidden={Boolean(isRequired)}>
          <Form.Item name={[id, 'name']} noStyle>
            <RevxCheckbox {...nameCheckboxProps} />
          </Form.Item>
        </div>
      </div>
    </>
  );
};

export default CommonJobSvcName;
